import type { Component } from 'solid-js'

type Props = {
  /** 放送中かどうか。false のときは待機表示になる */
  live?: boolean
}

/** 「● ON AIR」インジケータ */
export const OnAirBadge: Component<Props> = (props) => {
  const live = () => props.live !== false

  return (
    <span
      class="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.18em]"
      classList={{
        'text-ch-onair': live(),
        'text-ch-dim': !live(),
      }}
    >
      <span class="relative flex size-2 items-center justify-center">
        {live() && (
          <span
            class="absolute size-2 rounded-full bg-ch-onair animate-onair-pulse"
            aria-hidden="true"
          />
        )}
        <span
          class="relative size-2 rounded-full"
          classList={{ 'bg-ch-onair': live(), 'bg-ch-dim': !live() }}
        />
      </span>
      {live() ? 'ON AIR' : 'STANDBY'}
    </span>
  )
}
